(()=>{
    function handleInlinePromotionImagesVisibility(event){
        let productsCount = event.detail.data.productsCount;

        if (productsCount == null){
        productsCount = document.getElementById("product-grid").querySelectorAll('.product-card-2__wrapper')?.length;
        }

        if (productsCount != null){
        const inlineImagePromotions = document.querySelectorAll('.js-main-collection-2-inline-promo-image__wrapper.js-main-collection-2-inline-promo-image__wrapper--hidden');
        inlineImagePromotions.forEach(inlineImagePromotionEl => {
            const position = Number(inlineImagePromotionEl.dataset.position);
            const columnCount = window.innerWidth > 1023 ? 4: 2;

            const unhide = position * columnCount < productsCount;

            // console.log("handle inline filter", position * columnCount, productsCount);

            if (unhide){
            inlineImagePromotionEl.style.display = "grid";
            inlineImagePromotionEl.classList.remove("js-main-collection-2-inline-promo-image__wrapper--hidden");
            };
        })
        }
    }
    document.addEventListener("main-collection-2:inline-promotion-images-visibility:update", handleInlinePromotionImagesVisibility);
})();
